export default {
  name: "H-1B: Additional Employer Labor Condition Statements",
  pageInfo: {
    isVisible: {
      when: "a1_visa_type",
      is: "H-1B"
    },
    text: 'In order for your H-1B application to be processed, you <u>MUST</u> read Section H - Subsection 1 of the Form ETA 9035CP - General Instructions for the 9035 & 9035E under the heading "Additional Employer Labor Condition Statements" and answer the questions below.',
    coloring: "grey"
  },
	pageAlert: {
		widget: "pageAlert",
		alerts: [
			{
				title: "Information Required",
				description:
					"Please specify the type of visa classification supported by this application in Field A.1",
				type: "info",
				isVisible: {
          when: "a1_visa_type",
          is: 'untouched',
          operator:'untouched'
				}
			},
			{
				title: "Section Complete",
				description:
					"Because you indicated the type of visa classification supported by this application as something other than H-1B (per Section A), no Section H is necessary for this application.",
				type: "success",
				isVisible: {
					when: "a1_visa_type",
					is: ["H-1B1 Chile", "H-1B1 Singapore", "E-3 Australian"],
					operator: "||"
				}
			}
		]
	},
	sections: [
		{
			name: "Subsection 1",
			isVisible: {
				when: "a1_visa_type",
				is: "H-1B"
			},
			fields: [
				{
					isGroup: {
						machine_name: "h1_is_dependent",
						code: "H.1",
						label:
							"At the time of filing this LCA, is the employer H-1B dependent?",
						tooltip:
							'Indicate whether the employer is H-1B dependent at the time of filing. The employer is H-1B dependent if the number of H-1B nonimmigrant workers employed by the employer as a proportion of the total number of full-time equivalent employees employed in the United States matches the chart in the instructions. If an employer marks "No" and is or becomes H-1B dependent, the submitted LCA must not be used in support of a new petition or extension of a petition for an H-1B nonimmigrant worker. By marking "No", the employer also acknowledges that if it uses this application to support a new petition or extension of a petition despite its invalidity, it is required to comply with the Additional Employer Labor Condition Statements in Subsection 2 of Section H.',
						coloring: "none",
						required: true,
						fields: [
							{
								widget: "radio",
								choice: "Yes",
								value: "YES",
								validate: ["required"]
							},
							{
								widget: "radio",
								choice: "No",
								value: "NO",
								validate: ["required"], 
								clearSchema: ['h3_only_h1b', 'h4_exemption_basis']
							}
						]
					}
				},
				{
					isGroup: {
						machine_name: "h2_is_willful_violator",
						code: "H.2",
						label:
							"At the time of filing this LCA, is the employer a willful violator",
						tooltip:
							'Indicate whether the employer is a willful violator at the time of filing. The employer is a willful violator if the employer has been found during the five (5) years preceding the date of the application (and after October 20, 1998) to have committed a willful violation or a misrepresentation of a material fact. If an employer marks "No" and is found, prior to the date of filing, to have committed a willful violation or a misrepresentation, the submitted LCA must not be used in support of a new petition or extension of a petition for an H-1B nonimmigrant worker. By marking "No", the employer also acknowledges that if it uses this application to support a new petition or extension of a petition despite its invalidity, it is required to comply with the Additional Employer Labor Condition Statements in Subsection 2 of Section H.',
						coloring: "none",
						required: true,
						fields: [
							{
								widget: "radio",
								choice: "Yes",
								value: "YES",
								validate: ["required"],
								clearSchema: ['h6_read_agree']
							},
							{
								widget: "radio",
								choice: "No",
								value: "NO",
								validate: ["required"],
								clearSchema: ['h3_only_h1b', 'h4_exemption_basis']
							}
						]
					}
				},
				{
					isGroup: {
						isVisible: {
							when: "h1_is_dependent h2_is_willful_violator",
							is: "YES",
							operator: "compareMultiFieldValuesOR"
						},
						machine_name: "h3_only_h1b",
						code: "H.3",
						label:
							"Will the employer use this application <u>ONLY</u> to support H-1B petitions or extensions of status for exempt H-1B nonimmigrant workers?",
						tooltip:
							'If Yes to Item H.1 and/or Item H.2, indicate whether the employer intends to use this application ONLY to support H-1B petitions or extensions of status for H-1B nonimmigrant workers who are exempt, i.e., receive wages at a rate equal to at least $60,000 per year, or have attained a Master’s degree (or equivalent or higher degree) in a specialty related to the employment. The employer also agrees to maintain documentation required by 20 CFR 655.737. If an employer marks "Yes", the employer acknowledges that if it uses this application in support of a petition or extension of a petition of an H-1B nonimmigrant who is not exempt, it is required to comply with the Additional Employer Labor Condition Statements in Subsection 2 of Section H with respect to all H-1B nonimmigrant workers supported by this application.',
						coloring: "none",
						required: true,
						fields: [
							{
								widget: "radio",
								choice: "Yes",
								value: "YES",
								validate: ["required"],
								clearSchema: ['h6_read_agree']
							},
							{
								widget: "radio",
								choice: "No",
								value: "NO",
								validate: ["required"],
								clearSchema: ['h4_exemption_basis']
							}
						]
					}
				},
				{
					isGroup: {
						isVisible: {
							when: "h3_only_h1b",
							is: "YES"
						},

						machine_name: "h4_exemption_basis",
						code: "H.4",
						label:
							"Identify the statutory basis for the exemption of the H-1B nonimmigrant workers associated with this LCA.",
						tooltip:
							'If the employer responded "Yes" to an exemption in Item H.3, indicate the basis (or bases) of the exemption. Check a box for either $60,000 or higher annual wage, or Master’s Degree or higher in related specialty, or the box for "Both" if both exemptions are applicable.',
						coloring: "none",
						required: true,
                        warning: {
                            text:
                                "You must complete and attach Appendix A with documentation for any H-1B nonimmigrant worker where the statutory exemption for that worker will be based only on the Master's or higher degree exemption. The employer must report as many additional sections of educational attainment information as are necessary to cover all exempt H-1B nonimmigrant workers employed under the LCA.",
                            isVisible: {
                                when: "h4_exemption_basis",
                                is: "Master's Degree or higher in related speciality",
                                operator: "="
                            }
                        },
						fields: [
							{
								widget: "radio",
								choice: "$60,000 or higher annual wage",
								value: "$60,000 or higher annual wage",
								validate: ["required", {
									totalSalary9035: 'h4_exemption_basis',
									needsFieldValues: true
								}]
							},
							{
								widget: "radio",
								choice: "Master's Degree or higher in related speciality",
								value: "Master's Degree or higher in related speciality",
								validate: ["required"]
							},
							{
								widget: "radio",
								choice: "Both",
								value: "Both",
								validate: ["required",
									{
										totalSalary9035: 'h4_exemption_basis',
										needsFieldValues: true
									}]
							}
						]
					}
				}
			]
		},
		{
			name: "Subsection 2",
			isVisible: {
				when: "h1_is_dependent h2_is_willful_violator h3_only_h1b",
				is: ["YES", "NO"],
				operator: "conditionAndSetValue",
			},
			fields: [
					{
					isGroup: {
						hidden: true,
						code: 'H.5',
						machine_name: "h5_is_appendix_a_completed",
						fields: [
							{
								widget: 'radio',
								choice: 'Yes',
								value: 'YES',
							},
							{
								widget: 'radio',
								choice: 'Na',
								value: 'N/A',
							}
						]
					}
				},
				{
					widget: "alert",
					description: `
						<div>
							<small>A. <strong>Displacement</strong>: An H-1B dependent or willful violator employer is prohibited from displacing a U.S. worker in its own workforce within the period beginning 90 days before and ending 90 days after the date of filing of the visa petition. 20 CFR 655.738(c);</small><br/>
							<small>B. <strong>Secondary Displacement</strong>: An H-1B dependent or willful violator employer is prohibited from placing an H-1B nonimmigrant worker(s) with another/secondary employer where there are indicia of an employment relationship between the nonimmigrant worker(s) and that other/secondary employer (thus possibly affecting the jobs of U.S. workers employed by that other employer), unless and until the employer subject to this LCA makes the inquiries and/or receives the information set forth in 20 CFR 655.738(d)(5) concerning that other/secondary employer’s displacement of similarly employed U.S. workers in its workforce within the period beginning 90 days before and ending 90 days after the date of such placement. 20 CFR 655.738(d). Even if the required inquiry of the secondary employer is made, the H-1B dependent or willful violator employer will be subject to a finding of a violation of the secondary displacement prohibition if the secondary employer, in fact, displaces any U.S. worker(s) during the applicable time period; and</small><br/>
							<small>C. <strong>Recruitment and Hiring</strong>: Prior to filing this LCA or any petition or request for extension of status for nonimmigrant worker(s)supported by this LCA, the H-1B dependent or willful violator employer must take good faith steps to recruit U.S. workers for the job(s) using procedures that meet industry-wide standards and offer compensation that is at least as great as the required wage to be paid to the nonimmigrant worker(s) pursuant to 20 CFR 655.731(a). The employer must offer the job(s) to any U.S. worker who applies and is equally or better qualified for the job than the nonimmigrant worker. 20 CFR 655.739.</small><br/>
						</div>`,
					type: "none",
				},
				{
					isGroup: {
						machine_name: "h6_read_agree",
						code: "H.6",
						label:
							"<b>I have read and agree</b> to Additional Employer Labor Condition Statements A, B, and C above and as fully explained in Section H - Subsections 1 and 2 of the Form ETA 9035CP - General Instructions for the 9035 & 9035E and the Department's regulations at 20 CFR 655 Subpart H.",
						tooltip:
							'Indicate whether the employer has read and agrees to the additional employer labor conditions statements in Subsection 2(A) through (C). The employer must agree to all three labor condition statements of Section H, subsection 2. Answer this question only if the employer marked "Yes" to either or both questions in Item H.1 or Item H.2 (indicating that the employer is either an H-1B dependent employer or a willful violator, or both) and, also, the employer marked "No" to the question in Item H.3 ("No" to exempt H-1B nonimmigrant workers).',
						coloring: "none",
						required: true,
						fields: [
							{
								widget: "radio",
								choice: "Yes",
								value: "YES",
								validate: ["required"]
							},
							{
								widget: "radio",
								choice: 'No',
								value: "NO",
								validate: ["required", {"compareStringValue":"NO","message":"H-1B dependent and/or H-1B willful violators not claiming an exemption in H.a.3 must read and agree to the additional labor condition statements.", extraData: {
									operator: "==="
								  }}]
							  }
						]
					}
				}
			]
		}
	]
};
